import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-document-viewer-modal',
  template: `
    <div class="modal-header">
      <h5 class="modal-title">{{ title }}</h5>
      <button type="button" class="btn-close" (click)="activeModal.close()"></button>
    </div>
    <div class="modal-body p-0" style="height:80vh;overflow:auto;">
      <img *ngIf="isImage" [src]="dataUrl"
           style="max-width:100%;max-height:100%;object-fit:contain;display:block;margin:auto;" />
      <pdf-viewer *ngIf="isPdf"
        [src]="dataUrl"
        [rotation]="0"
        [original-size]="false"
        [show-all]="true"
        [fit-to-page]="true"
        [zoom]="1"
        [zoom-scale]="'page-width'"
        [render-text]="true"
        [autoresize]="true"
        style="display:block;width:100%;height:100%;">
      </pdf-viewer>
      <div *ngIf="isDocx" class="d-flex flex-column align-items-center justify-content-center h-100 p-4">
        <h5 class="mb-3">DOCX Preview Not Available</h5>
        <p class="text-muted mb-4">Word documents cannot be previewed in the browser.</p>
        <button type="button" class="btn btn-primary" (click)="downloadFile()">
         Download File
        </button>
      </div>
    </div>
  `,
})
export class DocumentViewerModalComponent {
  @Input() dataUrl!: string;
  @Input() title!: string;
  @Input() isImage!: boolean;
  @Input() contentType?: string;

  get isPdf(): boolean {
    return !this.isImage && !this.isDocx;
  }

  get isDocx(): boolean {
    return this.contentType?.includes('wordprocessingml') || this.contentType?.includes('docx') || false;
  }

  constructor(public activeModal: NgbActiveModal) {}

  downloadFile(): void {
    const link = document.createElement('a');
    link.href = this.dataUrl;
    link.download = this.title || 'document.docx';
    link.click();
  }
}
